import { PATHS } from "router/paths";

export const DocumentationLinksMap = new Map<string, Map<string, string>>([
  [
    PATHS.AGREEMENTS_DASHBOARD,
    new Map([
      ["en", "https://ucls.uname-it.com/portal/en/kb/articles/agreements-page-v8"],
      ["nl", "https://ucls.uname-it.com/portal/nl/kb/articles/overeenkomsten-pagina-v8"]
    ])
  ],
  [
    PATHS.ACSES_LOGS_DASHBOARD,
    new Map([
      ["en", "https://ucls.uname-it.com/portal/en/kb/articles/acses-locker-acses-logs-dashboard-v8"],
      ["nl", "https://ucls.uname-it.com/portal/nl/kb/articles/acses-sleutelkluis-dashboard-v8"]
    ])
  ],
  [
    PATHS.BACKORDERS_DASHBOARD,
    new Map([
      ["en", "https://ucls.uname-it.com/portal/en/kb/articles/backorder-dashboard-v8"],
      ["nl", "https://ucls.uname-it.com/portal/nl/kb/articles/backorder-dashboard-nl-v8"]
    ])
  ],
  [
    PATHS.CHECK_IN_SERVICES_DASHBOARD,
    new Map([
      ["en", "https://ucls.uname-it.com/portal/en/kb/articles/en-check-in-services-v8"],
      ["nl", "https://ucls.uname-it.com/portal/nl/kb/articles/check-in-services-v8"]
    ])
  ],
  [
    PATHS.COMMUNICATION_TEMPLATES,
    new Map([
      ["en", "https://ucls.uname-it.com/portal/en/kb/articles/templates-page-v8"],
      ["nl", "https://ucls.uname-it.com/portal/nl/kb/articles/templates-pagina-v8"]
    ])
  ],
  [
    PATHS.CUSTOMERS_DASHBOARD,
    new Map([
      ["en", "https://ucls.uname-it.com/portal/en/kb/articles/customers-overview-page-v8"],
      ["nl", "https://ucls.uname-it.com/portal/nl/kb/articles/klantenoverzicht-v8"]
    ])
  ],
  [
    PATHS.DEALER_OVERVIEW_DASHBOARD,
    new Map([
      ["en", ""],
      ["nl", ""],
      ["fr", ""]
    ])
  ],
  [
    PATHS.DEALER_REPORTS,
    new Map([
      ["en", "https://ucls.uname-it.com/portal/en/kb/articles/dealers-reports-v8"],
      ["nl", "https://ucls.uname-it.com/portal/nl/kb/articles/dealersrapporten-v8"]
    ])
  ],
  [
    PATHS.KIOSK_DASHBOARD,
    new Map([
      ["en", "https://ucls.uname-it.com/portal/en/kb/articles/check-in-kiosk-v8"],
      ["nl", "https://ucls.uname-it.com/portal/nl/kb/articles/check-in-kiosk-nl-v8"]
    ])
  ],
  [
    PATHS.KEYLOCKERS_DASHBOARD,
    new Map([
      ["en", "https://ucls.uname-it.com/portal/en/kb/articles/key-lockers-dashboard-v8"],
      ["nl", "https://ucls.uname-it.com/portal/nl/kb/articles/sleutelkluizen-dashboard-v8"]
    ])
  ],
  [
    PATHS.LEADS_DASHBOARD,
    new Map([
      ["en", "https://ucls.uname-it.com/portal/en/kb/articles/the-leads-page-v8"],
      ["nl", "https://ucls.uname-it.com/portal/nl/kb/articles/de-leads-functie-v8"]
    ])
  ],
  [
    PATHS.LOCATION_OVERVIEW_DASHBOARD,
    new Map([
      ["en", ""],
      ["nl", ""],
      ["fr", ""]
    ])
  ],
  [
    PATHS.LOCATION_REPORTS,
    new Map([
      ["en", "https://ucls.uname-it.com/portal/en/kb/articles/location-reports-v8"],
      ["nl", "https://ucls.uname-it.com/portal/nl/kb/articles/locatie-rapportages-v8"]
    ])
  ],
  [
    PATHS.MANUFACTURER_DASHBOARD,
    new Map([
      ["en", "https://ucls.uname-it.com/portal/en/kb/articles/manufacturer-dashboard-v8"],
      ["nl", "https://ucls.uname-it.com/portal/nl/kb/articles/fabrikant-dashboard-v8"]
    ])
  ],
  [
    PATHS.NEWS_DASHBOARD,
    new Map([
      ["en", "https://ucls.uname-it.com/portal/en/kb/articles/news-page-v8"],
      ["nl", "https://ucls.uname-it.com/portal/nl/kb/articles/nieuws-pagina-v8"]
    ])
  ],
  [
    PATHS.PARKING_GATE_CODES_DASHBOARD,
    new Map([
      ["en", "https://ucls.uname-it.com/portal/en/kb/articles/v8-parking-gate-codes"],
      ["nl", "https://ucls.uname-it.com/portal/nl/kb/articles/instellen-van-parkeerhek-pincodes-v8"]
    ])
  ],
  [
    PATHS.PRIVACY_AND_SECURITY_DASHBOARD,
    new Map([
      ["en", "https://ucls.uname-it.com/portal/en/kb/articles/gdpr-avg-regulation-claire"],
      ["nl", "https://ucls.uname-it.com/portal/nl/kb/articles/gdpr-avg-dpo-data-beveiliging"]
    ])
  ],
  [
    PATHS.SHAREBOX_DASHBOARD,
    new Map([
      ["en", "https://ucls.uname-it.com/portal/en/kb/articles/sharebox-log-dashboard-v8-en"],
      ["nl", "https://ucls.uname-it.com/portal/nl/kb/articles/sharebox-log-dashboard-v8-nl"]
    ])
  ],
  [
    PATHS.TYRE_DISCOUNTS_DASHBOARD,
    new Map([
      ["en", "https://support.claireit.eu/agent/claireit/support/help-center/page?articlestatus=latest#Solutions/dv/22834000027284008/en"],
      ["nl", "https://support.claireit.eu/agent/claireit/support/help-center/page?articlestatus=latest#Solutions/dv/22834000027266039/en"]
    ])
  ],
  [
    PATHS.USERS,
    new Map([
      ["en", "https://ucls.uname-it.com/portal/en/kb/articles/users-page-v8"],
      ["nl", "https://ucls.uname-it.com/portal/nl/kb/articles/gebruikerspagina-v8"]
    ])
  ],
  [
    PATHS.WARRANTY_DASHBOARD,
    new Map([
      ["en", "https://ucls.uname-it.com/portal/en/kb/articles/warranty-dashboard-v8"],
      ["nl", "https://ucls.uname-it.com/portal/nl/kb/articles/garantie-dashboard-v8"]
    ])
  ],
  [
    PATHS.WEBHOOKS_DASHBOARD,
    new Map([
      ["en", "https://ucls.uname-it.com/portal/en/kb/articles/creating-claire-s-webhooks-v8"],
      ["nl", "https://ucls.uname-it.com/portal/nl/kb/articles/claire-s-webhooks-aanmaken-v8"]
    ])
  ]
]);
